import { useVideoStreamCtx } from '@features/video/providers';

import { ButtonVideo } from './GameButtons';

// Кнопка видеоконтроля участника: состояние и модалка живут в VideoStreamProvider. Без
// видеоконтроля в турнире кнопки нет
export function ButtonVideoWidget() {
  const video = useVideoStreamCtx();
  if (!video?.visible) return null;
  return (
    <ButtonVideo
      source={video.source}
      accent={video.missing}
      live={video.status === 'live'}
      micOff={video.micOff}
      camOff={video.camOff}
      error={video.error}
      active={video.isModalOpen}
      onClick={video.toggleModal}
    />
  );
}
